<div class="crm-header">
  <header data-aos="zoom-in">
    <div class="container">
      <div class="row-custom">
        <div class="col-sm-12-custom">
          <div class="inner-header">
            <div class="logo">
            </div>
            <div class="menus">
              <nav class="animenu" [class.animenu--open]="menuOpen">
                <button class="animenu__btn" type="button" (click)="menuOpen = !menuOpen">
                  <span class="animenu__btn__bar"></span>
                  <span class="animenu__btn__bar"></span>
                  <span class="animenu__btn__bar"></span>
                </button>

                <ul class="animenu__nav">
                  <li><a (click)="changeTab('home'); menuOpen=false">Home</a></li>
                  <li><a (click)="changeTab('price'); menuOpen=false">Pricing</a></li>
                  <li><a [routerLink]="'/'" (click)="menuOpen=false">Login</a></li>
                  <li><a (click)="changeTab('retailer-Register'); menuOpen=false" *ngIf="currentTab !== 'retailer-Register'">SignUp</a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>
<div *ngIf="currentTab == 'home'">
  <app-crm-home [currency]="currency" [country]="countryName" [address]="priceAddress" [telephone]="priceTelephone"
    [email]="priceEmail"></app-crm-home>
</div>
<div *ngIf="currentTab == 'price'">
  <app-crm-price [currency]="currency" [country]="countryName" [address]="priceAddress" [telephone]="priceTelephone"
    [email]="priceEmail" (getStarted)="changeTab('retailer-Register')"></app-crm-price>
</div>

<div class="inner-page-bg-right" *ngIf="currentTab == 'retailer-Register'">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <div class="inner-header">
          <div class="logo">
            <a href="javascript:void();" [routerLink]="'/retailer-Register'">
              <img [src]="businesslogo" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="banner-inner-pages">
    <div class="container">
      <div class="row">
        <div class="col-sm-8  mb-5" [ngClass]="businessId ? 'mt-5' : 'mt-4'">
          <div class="banner-left-text">
            <h3 data-aos="fade-up" class="aos-init aos-animate">{{title}}</h3>
          </div>
          <br>
          <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()" autocomplete="off">
            <div class="row">
              <div class="col-sm-4">
                <mat-form-field appearance="outline">
                  <mat-label>User Type</mat-label>
                  <mat-select formControlName="userType" (selectionChange)="onChangeUserType()" disableOptionCentering>
                    <mat-option *ngFor="let userType of userTypeList" [value]="userType.code">
                      {{userType.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="submitted && f.userType.errors?.required" class="invalid-feedback">
                    User Type is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field appearance="outline">
                  <mat-label>Industrial Vertical</mat-label>
                  <mat-select formControlName="industryVertical" disableOptionCentering>
                    <mat-option *ngFor="let industryVertical of industryVerticalList" [value]="industryVertical.code">
                      {{industryVertical.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="submitted && f.industryVertical.errors?.required" class="invalid-feedback">
                    Industrial Vertical is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4" *ngIf="showBusinessStoreId">
                <mat-form-field appearance="outline">
                  <mat-label>Retail Store ID</mat-label>
                  <input matInput formControlName="businessStoreId" placeholder="Retail Store ID" type="text"
                    maxlength="25">
                </mat-form-field>
              </div>
              <div class="col-sm-4" style="display: none;">
                <mat-form-field appearance="outline">
                  <mat-label>Type Of Agency</mat-label>
                  <mat-select formControlName="typeOfAgency" disableOptionCentering>
                    <mat-option *ngFor="let typeOfAgency of typeOfAgencyList" [value]="typeOfAgency.code">
                      {{typeOfAgency.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="submitted && f.typeOfAgency.errors?.required" class="invalid-feedback">
                    Type Of Agency is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">
                <mat-form-field appearance="outline">
                  <mat-label>First Name</mat-label>
                  <input matInput formControlName="firstName" placeholder="First Name" type="text" maxlength="50"   (blur)="trimField('firstName')">
                 
                  <mat-error *ngIf="f.firstName.invalid && (f.firstName.dirty || f.firstName.touched)">
                    {{ getErrorMessage('firstName') }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field appearance="outline">
                  <mat-label>Last Name</mat-label>
                  <input matInput formControlName="lastName" placeholder="Last Name" type="text" maxlength="50"  (blur)="trimField('lastName')">
                 
                  <mat-error *ngIf="f.lastName.invalid && (f.lastName.dirty || f.lastName.touched)">
                    {{ getErrorMessage('lastName') }}
                  </mat-error>

                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field appearance="outline">
                  <mat-label>Company</mat-label>
                  <input matInput formControlName="company" placeholder="Company" type="text" maxlength="150"  (blur)="trimField('company')">
                   <mat-error *ngIf="f.company.invalid && (f.company.dirty || f.company.touched)">
                     {{ getErrorMessage('company') }}
                   </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <mat-form-field appearance="outline">
                  <mat-label>Password</mat-label>
                  <input matInput formControlName="password" placeholder="Password"
                    [type]="hidePassword ? 'password' : 'text'" maxlength="10">
                  <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()">
                    <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                  <mat-error *ngIf="submitted && f.password.errors?.required" class="invalid-feedback">
                    Password is required
                  </mat-error>
                  <button mat-icon-button matSuffix>
                    <mat-icon
                      matTooltip="1) Must contain Atleast 6 character 2) Must contain atleast 1 capital letter, 1 special character and 1 Numeric digit.">info</mat-icon>
                  </button>

                  <mat-error *ngIf="submitted && f.password.errors?.pattern" class="invalid-feedback">
                    Password must be at least 6 characters long, include 1 uppercase letter,1 special character, and 1
                    numeric
                    digit. </mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-6">

                <mat-form-field appearance="outline">
                  <mat-label>Confirm Password</mat-label>
                  <input matInput [type]="hidePasswordConfirm ? 'password' : 'text'" formControlName="confirmPassword"
                    placeholder="Confirm Password" maxlength="10" autocomplete="off" />
                  <button mat-icon-button matSuffix type="button" (click)="toggleConfirmPasswordVisibility()">
                    <mat-icon>{{ hidePasswordConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
                  </button>
                  <mat-error *ngIf="submitted && f.confirmPassword.errors?.required" class="invalid-feedback">
                    Confirm Password is required
                  </mat-error>
                  <mat-error class="invalid-feedback"
                    *ngIf="(f.confirmPassword.errors?.mustMatch && (registrationForm.touched || registrationForm.dirty))">
                    Password and confirm password doesn't match.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

             <div class="row topgap">
              <div class="col-sm-4">
                <mat-form-field appearance="outline">
                  <mat-label>Country</mat-label>
                
                  <input type="text" matInput AlphabeticOnly formControlName="country"
                    (ngModelChange)="onChangeCountry($event)" [matAutocomplete]="autoCountryId" autocomplete="disabled">
                  <mat-autocomplete #autoCountryId="matAutocomplete" [displayWith]="displayFnCountry">
                    <mat-option *ngFor="let country of countryFilterList" [value]="country.id">
                      {{country.name }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="submitted && f.country.errors?.required" class="invalid-feedback">
                    Country is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field appearance="outline">
                  <mat-label>State/Province</mat-label>
                
                  <input type="text" matInput AlphabeticOnly formControlName="state"
                    (ngModelChange)="onChangeState($event)" [matAutocomplete]="autoStateId" autocomplete="disabled">
                  <mat-autocomplete #autoStateId="matAutocomplete" [displayWith]="displayFnState">
                    <mat-option *ngFor="let state of stateFilterList" [value]="state.id">
                      {{state.name}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="submitted && f.state.errors?.required" class="invalid-feedback">
                    State/Province is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field appearance="outline">
                  <mat-label>City</mat-label>
              
                  <input type="text" matInput AlphabeticOnly formControlName="city"
                    (ngModelChange)="onChangeCity($event)" [matAutocomplete]="autoCityId" autocomplete="disabled">
                  <mat-autocomplete #autoCityId="matAutocomplete" [displayWith]="displayFnCity">
                    <mat-option *ngFor="let city of cityFilterList" [value]="city.id">
                      {{city.name}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="submitted && f.city.errors?.required" class="invalid-feedback">
                    City is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-8">
                <mat-form-field fxFlex="100" fxFlex.lt-md="100" fxFlex.lt-sm="100" appearance="outline">
                  <mat-label>Address</mat-label>
                    <textarea matInput formControlName="address" placeholder="Address" rows="4" maxlength="250"
                  (blur)="trimField('address')"></textarea>
                   <mat-error *ngIf="f.address.invalid && (f.address.dirty || f.address.touched)">
                     {{ getErrorMessage('address') }}
                   </mat-error>
                </mat-form-field>
              </div>
              <div class="col-sm-4">
                <mat-form-field fxFlex="100" fxFlex.lt-md="100" fxFlex.lt-sm="100" appearance="outline">
                  <mat-label>Postal Code</mat-label>
                  <input matInput AlphanumericOnly formControlName="postalCode" placeholder="Postal Code" type="text"
                    maxlength="10"  (blur)="trimField('postalCode')">
                   <mat-error *ngIf="f.postalCode.invalid && (f.postalCode.dirty || f.postalCode.touched)">
                  {{ getErrorMessage('postalCode') }}
                </mat-error>
                </mat-form-field>
              </div>
            </div>

           

            <div class="row">
              <div class="col-sm-8">
                <mat-form-field fxFlex="33" fxFlex.lt-md="50" fxFlex.lt-sm="100" appearance="outline">
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="email" oninput="this.value = this.value.toLowerCase()"
                    placeholder="Email ID" type="email" maxlength="50">
                  <mat-error *ngIf="submitted && f.email.errors?.required" class="invalid-feedback">
                    Email ID is required
                  </mat-error>
                  <mat-error *ngIf="submitted && f.email.errors?.pattern" class="invalid-feedback">
                    Please enter valid Email ID
                  </mat-error>
                </mat-form-field>
              </div>
           
              <div class="col-sm-4">
                <mat-form-field fxFlex="33" fxFlex.lt-md="50" fxFlex.lt-sm="100" appearance="outline">
                  <mat-label>Telephone</mat-label>
                  <span matPrefix>+{{countryCode}} &nbsp;</span>
                  <input matInput formControlName="telephone" placeholder="Telephone" type="tel" maxlength="15"
                    oninput="this.value = this.value.toLowerCase()" (keypress)="onlyNumbers($event)"  (blur)="trimField('telephone')">
                   <mat-error *ngIf="f.telephone.invalid && (f.telephone.dirty || f.telephone.touched)">
                     {{ getErrorMessage('telephone') }}
                   </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-10">
                <mat-checkbox formControlName="termsCondition" (change)="onClickTermCondition()">Terms & Conditions
                </mat-checkbox>
              </div>
              <div class="col-sm-2">
                <button style="width: 100%;" mat-flat-button routerLinkActive="active"
                  [disabled]="!f.termsCondition.value || isSubmitting" type="submit" color="primary">Sign Up
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="col-sm-4 aos-init aos-animate" data-aos="fade-up">
          <img class="login-image" src="../../../assets/crm_images/signup-1.png" alt="">
        </div>
      </div>
    </div>
  </section>
</div>
